import { render, staticRenderFns } from "./PazientiList.vue?vue&type=template&id=48d452be"
import script from "./PazientiList.vue?vue&type=script&lang=js"
export * from "./PazientiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports